export {
    baseNogenderColors,
    maleColorsByAge,
    femaleColorsByAge,
    nogenderColorsByAge,
    allGenderColorsList,
} from './chart-colors';
